import { Modifiers } from '@tanium/react-tooltip';

type PopperModifiers = NonNullable<Modifiers>;

// TODO: Revisit tooltip behavior. This is currently needed to avoid a flicker visible when the
// cursor covers the tooltip, causing it to disappear. It is also used to prevent the tooltip from
// interfering with pointer events (e.g., pointerout) that are used to determine the opacity of
// certain chart elements.
export const noPointerEventsTooltipModifiers: PopperModifiers = {
  disablePointerEvents: {
    enabled: true,
    // Execute after the computeStyle modifier (850),
    // and before the applyStyle modifier (900).
    // see https://popper.js.org/docs/v1/#modifiers
    order: 890,
    // Type assertion on `fn` is necessary due to false positive from
    // @typescript-eslint/explicit-module-boundary-types
    fn: ((data) => {
      // eslint-disable-next-line no-param-reassign -- required by popper
      data.styles.pointerEvents = 'none';
      return data;
    }) as NonNullable<PopperModifiers['disablePointerEvents']>['fn'],
  },
};
